import {
  ChatbotMessageAriaLabels,
} from './chatbot.types';

export const CHATBOT_ARIA_DEFAULTS: ChatbotMessageAriaLabels = {
  chatbot: 'Chatbot',
  close: 'Chatbot minimaliseren',
  avatar: 'Chatbot:',
  user: 'Jij:',
  message: 'Te verzenden bericht',
  send: 'Bericht verzenden',
  toggle: 'Een vraag stellen',
};
